<template>
    <oss-dialog
        v-if="addDocumentDialog"
        v-model="addDocumentDialog"
        :title="alreadyLinkedDoc ? 'Document lié' : 'Lier un ou plusieurs document(s)'"
        :actions="actions"
        :previous-display="dialogStep === 'displayDocument' && !alreadyLinkedDoc"
        @previous="dialogPreviousAction()"
        @close="closeDialog()"
        min-width="1500px"
    >
        <v-window v-model="dialogStep">
            <v-window-item value="addDocument">
                <v-tabs
                    v-model="activeTab"
                    style="
                        background-color: transparent !important;
                        border-radius: 16px;
                        overflow: hidden;
                    "
                >
                    <v-tab value="ExistingDocuments" href="#ExistingDocuments">
                        Documents existants
                    </v-tab>
                    <v-tab value="UploadDocument" href="#UploadDocument">
                        Ajouter un document
                    </v-tab>
                </v-tabs>
                <v-tabs-window v-model="activeTab">
                    <v-window-item value="ExistingDocuments">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <!-- Chercher un document déjà importé -->
                                <DocumentsTable
                                    v-if="addDocumentDialog"
                                    :selectMode="true"
                                    :actions="selectActions"
                                    :preSelectedAuditCheckDocuments="localConnectedDocuments || []"
                                    height="70vh"
                                    @documentIdToDisplay="displayDocument($event)"
                                    @addDocumentInList="addNewDocument($event)"
                                    @selectedDocuments="replaceList($event)"
                                    @validSelection="validDocumentsSelection"
                                />
                            </v-col>
                        </v-row>
                    </v-window-item>
                    <v-window-item value="UploadDocument">
                        <v-row no-gutters>
                            <!-- Importer un nouveau document -->
                            <v-col cols="12" class="d-flex justify-center">
                                <UploadDocuments
                                    v-if="addDocumentDialog && activeTab === 'UploadDocument'"
                                    :documentType="'MISCELLANEOUS'"
                                    ref="uploadDocuments"
                                    :showFirstPrevious="true"
                                    :companyId="companyId"
                                    :freeTag="false"
                                    :actions="uploadActions"
                                    :auditCheckMode="true"
                                    :inExtensions="[
                                        'jpeg',
                                        'jpg',
                                        'png',
                                        'tiff',
                                        'tif',
                                        'pdf',
                                        'docx',
                                        'xlsx',
                                        'csv',
                                    ]"
                                    @files-uploaded="onFilesUploaded"
                                    @new-document="addNewDocument($event)"
                                />
                            </v-col>
                        </v-row>
                    </v-window-item>
                </v-tabs-window>
            </v-window-item>
            <v-window-item value="displayDocument">
                <div style="height: 80vh">
                    <Document
                        v-if="documentToShow"
                        :mode="'GeneralLedger'"
                        :companyId="companyId"
                        :id="documentToShow.id"
                        :dark-mode="true"
                    />
                </div>
            </v-window-item>
        </v-window>
    </oss-dialog>
</template>

<script lang="ts">
import { cloneDeep, isEqual } from "lodash";
import { DocumentNode } from 'graphql'

import DocumentsTable from "../document/DocumentsTable.vue";
import UploadDocuments from "../document/UploadDocuments.vue";

import { DialogAction } from "../../services/dialogAction";

import { Component, Model, Prop, toNative, Vue, Watch } from "vue-facing-decorator";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpdateAuditCheckResultConnectedDocuments.gql";
import UPSERT_AUDIT_CHECK_RESULT_CLOSURE from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import Document from "../document/DocumentRouter.vue";

@Component({
    components: {
        UploadDocuments,
        DocumentsTable,
        Document,
    },
    emits: ["resetDialogData", "upsertedAuditCheckResult", "documentsUploaded", "documentAdded"],
})
export class AuditCheckDocumentsManager extends Vue {
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: false }) value: boolean;
    @Prop({ default: null }) documentToDisplay: any;
    // @Prop({ default: null }) documents: any
    @Prop({ default: null }) connectedDocuments: any;
    @Prop({ default: "" }) acKey: string;
    @Prop({ default: null }) auditCheckResult: any;
    @Prop({ default: "" }) accountingPeriodId: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) alreadyLinkedDoc: boolean;
    documentToShow: any = null;

    @Model() addDocumentDialog: boolean;

    get dialogStep() {
        return this.documentToShow?.id ? "displayDocument" : "addDocument";
    }

    activeTab: string = "ExistingDocuments";

    localConnectedDocuments: Array<any> = [];
    localDocumentToDisplay: any = null;

    baseActions = {
        action: new DialogAction(),
    };

    uploadActions = {
        action: new DialogAction(),
    };

    selectActions = {
        action: new DialogAction(),
    };

    get actions() {
        if (this.dialogStep === "addDocument") {
            if (this.activeTab === "ExistingDocuments") {
                return this.selectActions;
            } else if (this.activeTab === "UploadDocument") {
                return this.uploadActions;
            }
        }
        if (this.dialogStep === "displayDocument") {
            return this.baseActions;
        }
    }

    // -- look if to delete
    get validTitle() {
        if (this.dialogStep === "addDocument" && this.activeTab === "ExistingDocuments") {
            return "Ajouter la sélection";
        } else if (this.dialogStep === "addDocument" && this.activeTab === "UploadDocument") {
            return "Démarrer";
        } else {
            return "Ajouter";
        }
    }

    // -- look if to delete
    getValidAction() {
        if (this.alreadyLinkedDoc) {
            return this.closeDialog();
        } else {
            return this.selectExistingDocument();
        }
    }

    // -- look if to delete
    dialogPreviousAction() {
        this.documentToShow = null;
        this.clearDocument();
    }

    // -- look if to delete
    async selectExistingDocument() {
        this.selectDocument(this.documentToShow);
        await this.upsertAuditCheckResult();
        this.closeDialog();
    }

    async validDocumentsSelection() {
        await this.upsertAuditCheckResult();
        this.closeDialog();
    }

    toggleAddDocumentDialog() {
        this.clearDocument();
        this.addDocumentDialog = !this.addDocumentDialog;
        this.clearDocument();
    }

    displayDocument(document) {
        this.documentToShow = document;
    }

    resetDialogData() {
        this.activeTab = "ExistingDocuments";
        this.clearDocument();
        this.documentToShow = null;
        this.$emit("resetDialogData");
    }

    closeDialog() {
        if (!isEqual(this.localConnectedDocuments, this.connectedDocuments)) {
            this.$emit("upsertedAuditCheckResult");
        }
        this.addDocumentDialog = false;
        this.resetDialogData();
    }

    beforeMount() {
        if (this.documentToDisplay) {
            this.documentToShow = this.documentToDisplay;
        }
        if (this.alreadyLinkedDoc) {
            this.baseActions.action.display = true;
            this.baseActions.action.disabled = false;
            this.baseActions.action.title = "Fermer";
            this.baseActions.action.function = this.getValidAction;
        } else {
            this.baseActions.action.display = true;
            this.baseActions.action.disabled = false;
            this.baseActions.action.title = "Sélectionner";
            this.baseActions.action.function = this.getValidAction;
        }
    }

    @Watch("connectedDocuments", { immediate: true, deep: true })
    setlocalConnectedDocuments() {
        this.localConnectedDocuments = cloneDeep(this.connectedDocuments);
    }

    @Watch("localDocumentToDisplay", { immediate: true, deep: true })
    setDocumentToShow() {
        this.documentToShow = cloneDeep(this.localDocumentToDisplay);
    }

    async validateNewDocuments() {
        await this.upsertAuditCheckResult();
        this.closeDialog();
    }

    async onFilesUploaded({ createdDocIds }) {
        const formatedList = createdDocIds.map((id) => ({ id }));
        this.localConnectedDocuments.push(...formatedList);
        await this.upsertAuditCheckResult();
        this.closeDialog();
    }

    addNewDocument(document) {
        this.localConnectedDocuments.push(document);
    }

    // -- look if to delete
    selectDocument(document) {
        debugger;
        this.localConnectedDocuments.push(document);
    }

    clearDocument() {
        this.localDocumentToDisplay = null;
    }

    replaceList(localConnectedDocuments) {
        this.localConnectedDocuments = localConnectedDocuments;
    }

    /**
     * Upsert the audit check result with the connected documents
     *  or create a new audit check result if it doesn't exist yet
     */
     async upsertAuditCheckResult(): Promise<void> { 

        // params of request mutation
        let auditCheckResultVariables: any = null;

        if (this.auditCheckResult?.id) {

            let connectedDocumentIds: Array<any> = [];

            if (this.localConnectedDocuments) {
                connectedDocumentIds = this.localConnectedDocuments.map((doc) => doc.id);
            }

            auditCheckResultVariables = {
                acrId: this.auditCheckResult?.id,
                connectDocuments: connectedDocumentIds || [],
            };

            await this.upsertAuditCheckResultCall(UPSERT_AUDIT_CHECK_RESULT, auditCheckResultVariables);
        
        }
        else if (this.acKey && this.companyId && this.accountingPeriodId) {
            // Create a new audit check result if it doesn't exist yet
            let connectedDocumentObjectIds: Array<any> = [];

            if (this.localConnectedDocuments) {
                connectedDocumentObjectIds = this.localConnectedDocuments.map((doc) => ({ id: doc.id }));
            }

            auditCheckResultVariables = {
                id: "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                status: "EDITION",
                // thirdPartyCompanyCreate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                // thirdPartyCompanyUpdate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                data: {},
                // documents: this.documents || undefined,
                // deleteDocuments: this.previousDocumentsIds || undefined,
                connectDocuments: connectedDocumentObjectIds || undefined,
                connectOdsToResults: [],
                auditCheckKey: this.acKey,
                type: "IN_AUDIT_REPORT",
            };

            await this.upsertAuditCheckResultCall(UPSERT_AUDIT_CHECK_RESULT_CLOSURE, auditCheckResultVariables);
        }

       
    }

    /**
     * Save the audit check result with the connected documents
     * @param mutationGql 
     * @param auditCheckResultVariables 
     */
    private async upsertAuditCheckResultCall(mutationGql: DocumentNode, auditCheckResultVariables: any): Promise<void> {
        if (auditCheckResultVariables && mutationGql) {
            await this.$apollo.mutate({
                mutation: mutationGql,
                variables: auditCheckResultVariables,
            });
        }
    }
  

}

export default toNative(AuditCheckDocumentsManager);
</script>
